<template>
	<div class="login">
		<iframe class="imgcenter scene" scrolling="no" :src="src" frameborder="0"></iframe>
		<div class="loginbox">
			<div class="left">
				<img class="imgcenter " src="../../../static/login/dlbj.png" mode="aspectFill" />

<!--				<iframe class="imgcenter scene" scrolling="no" :src="src" frameborder="0"></iframe>-->
			</div>
			<div class="right">
				<div class="rightBox">
					<div class="firstLine">
						<!-- <div class="icon"></div> -->
						登录
					</div>
					<div class="secondLine">
						<div class="usernameIcon"></div>
						<input v-model="username" type="text" placeholder="用户账号" @keyup.enter="login"/>
					</div>
					<div class="thirdLine">
						<div class="passwordIcon"></div>
						<input v-model="password" type="password" placeholder="密码" @keyup.enter="login"/>
					</div>
					<div class="fourthLine">
						<div class="fourthLineleft">
							<div class="icon"></div>
							<div class="text">记住密码</div>
						</div>
						<div class="fourthLineright sbs" @click="nav('/forget')">忘记密码?</div>
					</div>
					<div class="btn sbs" @click="login('/')">登陆</div>
					<div class="fifthLine">
						<div class="text">还没账户？</div>
						<div class="a sbs" @click="nav('/register')">立即注册</div>
						<div class="icon"></div>
					</div>
					<div class="sixthLine">
						<div class="title">
							<div class="line"></div>
							<div class="messgetitle">第三方登录</div>
							<div class="line"></div>
						</div>
						<div class="link">
							<img src="../../../static/login/wx.png" alt="" class="item sbs" />
							<img src="../../../static/login/qq.png" alt="" class="item sbs qq" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {httpGet,httpPost} from "../../utils/request.js"
import store from "@/store";
export default {
	data() {
		return {
			src: 'http://127.0.0.1:8848/youth-entrepreneurship-web/public/index5.html',
      username:'',
      password:''
		};
	},
	methods: {
		nav(e) {
			this.$router.push({ path: e, query: {} });
		},
    usernameFun(e){

		  this.username = e.data
    },
    passwordFun(e){
      this.password = e.data
    },
		login(e) {
		  let param = {
        username:this.username,
        password:this.password,
      }
      let that = this;
			httpPost('/web/login',param).then(res=>{
				if(res.success){
          that.$store.state.token = res.result.token
          that.$store.state.userInfo = res.result.userInfo
          that.$store.state.departs = res.result.departs
          that.$message({
            showClose: true,
            message: res.message,
            type: 'success'
          });
          that.$router.push("/")
        }else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          });
        }
			}).catch(error=>{
				console.log('error')
			})

		}
	},
	mounted() {
		// require('../../../component/demo5.js');
	}
};
</script>

<style lang="scss" scoped>
page,
.login {
	background: #f4f5f9;
	height: 100vh;
	overflow: hidden;
	width: 100vw;
	position: relative;
	.scene {
		position: absolute;
		width: 100vw;
		height: 100vh;
		z-index: 1;
	}
}
.loginbox {
	// display: flex;
	// justify-content: space-evenly;
	// margin: 5px auto;
	overflow: hidden;
	width: 100vw;
	height: 100vh;
	position: fixed;
	z-index: 20;
	// .left {
	// 	width: 62.65625vw;
	// 	height: 100vh;
	// 	float: left;
	// 	// height: auto !important;
	// 	overflow: hidden;
	// 	position: relative !important;
	// 	img {
	// 		position: absolute;
	// 		width: 100%;
	// 		height: 100%;
	// 		z-index: 1;
	// 	}

	// 	.title{
	// 		width: 4.4px;
	// 		height: 63px;
	// 		font-size: 68px;
	// 		font-family: Source Han Sans CN;
	// 		font-weight: 500;
	// 		color: #FFFFFF;
	// 		position: absolute;
	// 		z-index: 44;
	// 		left: 50%;
	// 		margin-left: -2.2px;
	// 		top: 94px;
	// 		text-align: center;
	// 		// line-height: 71px;
	// 	}
	// 	.subtitle{
	// 		text-align: center;
	// 		width: 100%;
	// 		height: 19px;
	// 		font-size: 24px;
	// 		font-family: Source Han Sans CN;
	// 		font-weight: bold;
	// 		color: #FFFFFF;
	// 		top: 1.94px;
	// 		position: absolute;
	// 		z-index: 44;
	// 		left:0;
	// 	}
	// }
	// .right {
	// 	float: right;
	// 	width: 37.34375vw;
	// 	height: 100vh;
	// 	background-color: #ffffff;
	// 	position: relative;
	.rightBox {
		width: 400px;
		height: 550px;
		padding: 30px 90px;
		position: absolute;
		z-index: 20;
		border-radius: 10px;
		background-color: #ffffff;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;

		transform: scale(0.75);
		// margin-top: 3.12px;
		// margin-left: 1.47px;
		.firstLine {
			overflow: hidden;
			text-align: center;
			font-size: 40px;
			// width: 2.13px;
			// height: 35px;
			// .icon {
			// 	width: 2.5px;
			// 	height: 67px;
			// 	float: left;
			// 	margin-right: 22px;
			// 	background: url(../../../static/login/logo.png) no-repeat center / 100%;
			// }
			// .title {
			// 	font-size: 46px;
			// 	font-weight: normal;
			// 	color: #666666;
			// }
		}
		.secondLine,
		.thirdLine {
			border-bottom: 1px solid #dddddd;
			padding-bottom: 14px;
			width: 100%;

			// flex-wrap: nowrap;
			overflow: hidden;
			margin-top: 33px;

			.usernameIcon {
				width: 30px;
				height: 30px;
				background: url(../../../static/login/yhm.png) no-repeat center / 100%;
				float: left;
				margin-right: 12px;
			}
      .passwordIcon {
        width: 30px;
        height: 30px;
        background: url(../../../static/login/mm.png) no-repeat center / 100%;
        float: left;
        margin-right: 12px;
      }
			input {
				// margin: 14px 0;
				float: left;
				padding: 0;
				width: 348px;
				height: 32px;
				font-size: 16px;
				margin: 0;
				border: none;

				color: #333333;
			}
		}
		.fourthLine {
			width: 100%;
			margin-top: 15px;
			margin-bottom: 41px;
			line-height: 32px;
			overflow: hidden;
			// display: flex;
			// justify-content: space-between;
			overflow: hidden;
			.fourthLineleft {
				overflow: hidden;
				float: left;
				.icon {
					width: 14px;
					height: 14px;
					border: 1px solid #00bdff;
					border-radius: 1px;
					// background: url(../../../static/login/logo.png) no-repeat center/100%;
					margin-top: 6px;
					float: left;
				}
				.text {
					font-size: 16px;
					font-weight: 400;
					color: #bbbbbb;
					margin-left: 4px;
					float: left;
				}
			}
			.fourthLineright {
				float: right;
				font-weight: 400;
				color: #00bdff;
				font-size: 16px;
			}
		}
		.btn {
			width: 100%;
			height: 60px;
			background: #00bdff;
			border-radius: 06px;
			font-size: 17px;
			font-weight: 400;
			color: #ffffff;
			text-align: center;
			line-height: 60px;
		}
		.fifthLine {
			width: 100%;
			// display: flex;
			// justify-content: center;
			text-align: center;
			margin: 0 auto;
			text-align: center;
			overflow: hidden;
			word-wrap: break-word;
			word-break: normal;
			margin-top: 34px;
			font-size: 17px;

			// line-height: 18px;
			.icon {
				margin-top: 04px;
				margin-left: 02px;
				// float: left;
				display: inline-block;
				width: 18px;
				height: 18px;
				background: url(../../../static/login/mode.png) no-repeat center/100% 100%;
			}
			.text {
				color: #666666;
				// float: left;
				display: inline-block;
			}
			.a {
				color: #00bdff;
				display: inline-block;
				// float: left;
			}
		}
		.sixthLine {
			width: 80%;
			margin: 0 auto;
			overflow: hidden;
			margin-top: 30px;
			.title {
				width: 100%;
				// display: flex;
				// justify-content: space-evenly;
				text-align: center;
				line-height: 16px;
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				.line {
					border-top: 1px solid #999999;
					width: 60px;
					height: 6px;
					// margin-top: 08px;
				}
				.messgetitle {
					margin: 0 30px;
				}
				& > div {
					display: inline-block;
					text-align: center;
				}
			}
			.link {
				width: 50%;
				margin: 0 auto;
				height: auto;
				overflow: hidden;
				// display: flex;
				// justify-content: space-around;
				margin-top: 30px;
				.item {
					float: left;
					width: 50px;
					height: 50px;
				}
				.qq {
					float: right;
					width: 30px;
					height: 35px;
					margin-top: 7.5px;
				}
			}
		}
	}
	// }
}
</style>
